import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "dashboard--container pa--top-1" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-6 col-xl-3 ma--bottom-1" }
const _hoisted_8 = { class: "card-content ma--top-1" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-8" }
const _hoisted_11 = { class: "text--weight-bold card-content--count" }
const _hoisted_12 = { class: "card-content--text" }
const _hoisted_13 = { class: "col-4 text--align-center" }
const _hoisted_14 = ["data-tooltip"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-id-badge card-content--icon" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "col-md-6 col-xl-3 ma--bottom-1" }
const _hoisted_18 = { class: "card-content ma--top-1" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-8" }
const _hoisted_21 = { class: "text--weight-bold card-content--count" }
const _hoisted_22 = { class: "card-content--text" }
const _hoisted_23 = { class: "col-4 text--align-center" }
const _hoisted_24 = ["data-tooltip"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-cart-arrow-down card-content--icon" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "col-md-6 col-xl-3 ma--bottom-1" }
const _hoisted_28 = { class: "card-content ma--top-1" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = { class: "text--weight-bold card-content--count" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card-content--text" }, "Total Spent", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 text--align-center" }, [
  /*#__PURE__*/_createElementVNode("div", { "data-tooltip": "This is the total amount you have spent to date." }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fa fa-dollar-sign card-content--icon" })
  ])
], -1)
const _hoisted_34 = { class: "col-md-6 col-xl-3 ma--bottom-1" }
const _hoisted_35 = { class: "card-content ma--top-1" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-8" }
const _hoisted_38 = { class: "text--weight-bold card-content--count" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "card-content--text" }, "Active Sites", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 text--align-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "left",
    "data-tooltip": "This is the number of active sites getting tracked."
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "fa fa-sitemap card-content--icon",
      style: {"padding-left":"18px"}
    })
  ])
], -1)
const _hoisted_41 = { class: "row ma--bottom-1" }
const _hoisted_42 = { class: "col-xl-12" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = { class: "card-header" }
const _hoisted_45 = { class: "card-header--title text--weight-bold text--size-1-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chart-bar" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "info",
  "data-tooltip": "This is a summary of lead batches by date."
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
], -1)
const _hoisted_48 = { class: "card-content" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-xl-6 col-md-12 ma--bottom-1" }
const _hoisted_51 = {
  key: 0,
  class: "card"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\"><div class=\"card-header--title text--weight-bold text--size-1-3\"><i class=\"fa fa-location-arrow\"></i> Top Locations <div class=\"info\" data-tooltip=\"This is an overview of your statistics.\"><i class=\"fa fa-info-circle\"></i></div></div></div>", 1)
const _hoisted_53 = { class: "card-content table--container" }
const _hoisted_54 = { class: "table table--striped" }
const _hoisted_55 = { class: "table--header" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "ZipCode", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "State", -1)
const _hoisted_58 = { class: "text--align-right" }
const _hoisted_59 = { class: "text--align-left" }
const _hoisted_60 = { class: "text--align-left" }
const _hoisted_61 = { class: "text--align-right" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No lead yet!"
    })
  ])
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "col-xl-6 col-md-12 ma--bottom-1" }
const _hoisted_66 = {
  key: 0,
  class: "card"
}
const _hoisted_67 = { class: "card-header" }
const _hoisted_68 = { class: "card-header--title text--weight-bold text--size-1-3" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-store" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", {
  class: "info",
  "data-tooltip": "This is an overview of your statistics."
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
], -1)
const _hoisted_71 = { class: "card-content table--container" }
const _hoisted_72 = { class: "table table--striped" }
const _hoisted_73 = { class: "table--header" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Date", -1)
const _hoisted_75 = { class: "text--align-left" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, "Credits", -1)
const _hoisted_77 = { class: "text--align-left" }
const _hoisted_78 = { class: "text--align-left" }
const _hoisted_79 = { class: "text--align-right" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No purchases yet!"
    })
  ])
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = { class: "row ma--bottom-1" }
const _hoisted_84 = { class: "col-xl-12" }
const _hoisted_85 = { class: "card" }
const _hoisted_86 = { class: "card-header" }
const _hoisted_87 = { class: "card-header--title text--weight-bold text--size-1-3" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", {
  class: "info",
  "data-tooltip": "This is an overview of your statistics."
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
], -1)
const _hoisted_90 = { class: "card-content" }
const _hoisted_91 = {
  key: 0,
  class: "table table--striped"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("thead", { class: "table--header" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Lead Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "State"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Zipcode")
  ])
], -1)
const _hoisted_93 = { class: "text--align-left" }
const _hoisted_94 = { class: "text--align-left" }
const _hoisted_95 = { class: "text--align-left" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_98 = [
  _hoisted_97
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.response)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "card card--secondary__blue",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToNextPage('leads', 'Available'))),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.response.leadsAvaialable)), 1),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s Available", 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            "data-tooltip": `This is the number of new ${_ctx.leadName}s collected by the Pixel.`
                          }, _hoisted_16, 8, _hoisted_14)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "card card--primary__teal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToNextPage('leads', 'Purchased'))),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.response.purchasedLeads)), 1),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s Purchased", 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            "data-tooltip": `This is the aggregate number of ${_ctx.leadName}s purchased to date.`
                          }, _hoisted_26, 8, _hoisted_24)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: "card card--tertiary__blue",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToNextPage('billing'))),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.response.totalSpent, 0, 0, "$")), 1),
                          _hoisted_32
                        ]),
                        _hoisted_33
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "card card--primary__purple",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToNextPage('sites'))),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.activeSites), 1),
                          _hoisted_39
                        ]),
                        _hoisted_40
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createTextVNode(" Current " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s to Date ", 1),
                    _hoisted_47
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  (_ctx.response.leadsByDate)
                    ? (_openBlock(), _createBlock(_component_BarChart, {
                        key: 0,
                        xAxis: _ctx.xAxis,
                        chartData: _ctx.chartData
                      }, null, 8, ["xAxis", "chartData"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              (_ctx.response.topLeads)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("table", _hoisted_54, [
                        _createElementVNode("thead", _hoisted_55, [
                          _createElementVNode("tr", null, [
                            _hoisted_56,
                            _hoisted_57,
                            _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s", 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.topLeads, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_59, _toDisplayString(item.zipcode), 1),
                              _createElementVNode("td", _hoisted_60, _toDisplayString(item.state), 1),
                              _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.$filters.numberDisplay(item.count)), 1)
                            ]))
                          }), 128)),
                          (_ctx.response.topLeads.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_62, _hoisted_64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_65, [
              (_ctx.response.topPurchasedLeads)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createTextVNode(" Recent " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s Purchased ", 1),
                        _hoisted_70
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("table", _hoisted_72, [
                        _createElementVNode("thead", _hoisted_73, [
                          _createElementVNode("tr", null, [
                            _hoisted_74,
                            _createElementVNode("th", _hoisted_75, _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s", 1),
                            _hoisted_76
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.topPurchasedLeads, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.$filters.dateDisplay(item.purchaseDate)), 1),
                              _createElementVNode("td", _hoisted_78, [
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateToNextPage('leads', 'Purchased')))
                                }, _toDisplayString(_ctx.$filters.numberDisplay(item.totalLeads)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.$filters.numberDisplay(item.totalCreditUsed)), 1)
                            ]))
                          }), 128)),
                          (_ctx.response.topPurchasedLeads.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_80, _hoisted_82))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _createTextVNode(" Recent " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s ", 1),
                    _hoisted_89
                  ])
                ]),
                _createElementVNode("div", _hoisted_90, [
                  (_ctx.leadsResponse)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_91, [
                        _hoisted_92,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadsResponse.data, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_93, _toDisplayString(_ctx.$filters.dateDisplay(item.createdTime)), 1),
                              _createElementVNode("td", _hoisted_94, _toDisplayString(item.state), 1),
                              _createElementVNode("td", _hoisted_95, _toDisplayString(item.zipcode), 1)
                            ]))
                          }), 128)),
                          (_ctx.leadsResponse.data.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_96, _hoisted_98))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
  ]))
}